<template>
    <button @click.stop="toggleSearch" class="footer-button">
        <svg width="20px" height="20px" viewBox="0 0 18 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Search-/-Explore" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Main---New-Nav" transform="translate(-108.000000, -746.000000)" stroke="#000000" stroke-width="1.2">
                    <g id="Group-3" transform="translate(109.000000, 747.000000)">
                        <circle id="Oval" cx="6.8" cy="6.8" r="6.8"></circle>
                        <line x1="11.2" y1="12" x2="16" y2="17.6" id="Line-8" stroke-linecap="round"></line>
                    </g>
                </g>
            </g>
        </svg>
        <span>Explore</span>
    </button>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
        },
        methods: {
            toggleSearch(){
                this.$store.commit({
                    type: 'search/toggleSearchOpen'
                });
                this.$router.push({
                    hash: 'search-opened'
                });
                this.$emit('click');
            },
        }
    }
</script>
